import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { CardsEventType } from './cards.event.type';
import { TweenMax, Quint } from 'gsap';
import { Card } from './model/card';
import { FormGroup } from '@angular/forms';
import { Auth } from '../../autentication/Auth';

@Component({
	selector: 'app-cards',
	templateUrl: './cards.component.html',
	styleUrls: ['./cards.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CardsComponent implements OnInit, OnDestroy {

	public title: string = 'Meus Cartões';
	public cardData = new Card();
	private form: FormGroup;
	public canSend: boolean = false;
	public hasSubmited: boolean = false;
	public activeBackButton: boolean = false;

	constructor() { }

	ngOnInit() {
		TweenMax.delayedCall(.4, () => {
			if (Auth.getInstance().getSessionCardNum()) {
				this.cardData.num = Auth.getInstance().getSessionCardNum();
				AppEventDispatcher.dispatch(CardsEventType.STEPS.DATA_CARDS, { show: false });
			} else {
				AppEventDispatcher.dispatch(CardsEventType.STEPS.DATA_CARDS, { show: true });
				AppEventDispatcher.dispatch(CardsEventType.ACTIONS.BUTTONS, { show: true });

			}
		});

		AppEventDispatcher.listen(CardsEventType.ACTIONS.BUTTONS, data => {
			if (data.show) {
				TweenMax.to('.buttons', .8, { bottom: 0, ease: Quint.easeOut });
			} else {
				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, { bottom: '-100%', ease: Quint.easeOut });
				});
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CardsEventType.ACTIONS.BUTTONS);
		AppEventDispatcher.removeListener(CardsEventType.ERROR);
	}

	onSetForm(form: FormGroup) {
		this.form = form;
		this.canSend = false;
	}

	sendForm() {
		this.hasSubmited = true;

		if (this.form.valid && !this.canSend) {

			this.canSend = true;

			this.hasSubmited = false;

			if (this.form.controls.numCard) {
				this.cardData.num = this.form.controls.numCard.value;
				Auth.getInstance().setSessionCardNum(this.cardData.num);
				TweenMax.delayedCall(.3, () => {
					AppEventDispatcher.dispatch(CardsEventType.STEPS.DATA_CARDS, { show: false });
				});
			} else if (this.form.controls.passwords) {
				this.cardData.pass = this.form.controls.passwords.value.password;
				TweenMax.delayedCall(.3, () => {
					AppEventDispatcher.dispatch(CardsEventType.STEPS.CHANGE_PASS, { show: false });
				});
			} else {
				TweenMax.delayedCall(.3, () => {
					AppEventDispatcher.dispatch(CardsEventType.STEPS.CONFIRM_CARDS, { show: false });
				});
			}
		}
	}

	onSetTitle(data) {
		this.title = data.title;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards/cards.component.ts